import React from 'react';
import { useHistory } from 'react-router-dom';
import SideBarItem from './SideBarItem';
import { doLogout } from '../../services/AuthService';
import { AppButton } from '../AppButton/AppButton';

function SideBar() {
    const history = useHistory();

    function cleanAndRedirect() {
        localStorage.removeItem('token');
        history.push('/');
    }

    function onLogoutClick() {
        doLogout()
            .then(() => cleanAndRedirect())
            .catch(() => cleanAndRedirect());
    }

    return (
        <nav id="sidebarMenu" className="sidebar-shell">
            <ul className="flex flex-col gap-0.5 p-[1vw]">
                <SideBarItem to="/dashboard" text="Dashboard" />
                <SideBarItem to="/users" text="Users" />
                <SideBarItem to="/limits" text="Limits" />
                <SideBarItem to="/settings" text="System" />
                <SideBarItem to="/symbols" text="Symbols" />
                <SideBarItem to="/logs" text="Logs" />

                <li className="list-none mt-4 pt-3 border-t border-blue-200">
                    <div className="sidebar-auth-actions px-1">
                        <AppButton variant="logout" size="sm" fullWidth onClick={onLogoutClick}>
                            Logout
                        </AppButton>
                    </div>
                </li>
            </ul>
        </nav>
    );
}

export default SideBar;
